<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Evaluation/components/Program/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>